export default __webpack_public_path__ + "45db89e1d87385662665cc4f45cec8d2.svg";